<template>
  <div>
    <validation-component
      ref="businessFormRef"
      :validation-condition="businessCondition">
    </validation-component>
    <div class="margin-top-20">
    <el-button
      style="width: 100%"
      type="primary"
      @click="onSubmit"
      >{{ $t("message.common.next") }}</el-button>
    </div>
  </div>
</template>

<script>
import { REQUIRED, ENGLISH_NAME } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { REGISTRATION_OPTIONS } from '@/views/account/information/api/options';

export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ValidationComponent,
  },
  data() {
    return {
      businessCondition: [
        {
          key: 'registration',
          name: 'message.user.businessRegistration',
          type: 'select',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          placeholder: this.$t('message.validator.select', { select: this.$t('message.user.businessRegistration').toLowerCase() }),
          options: REGISTRATION_OPTIONS,
          isInternationalization: true,
        },
        {
          key: 'merchantName',
          name: 'message.user.merchantName',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          maxLength: 100,
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.merchantName').toLowerCase() }),
        },
      ],
    };
  },
  created() {
    if (`${this.info.businessType}` === '0') { // 付款商户时，新增字段
      this.businessCondition.push({
        key: 'merchantNameEn',
        name: 'message.user.merchantNameEn',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED, ENGLISH_NAME],
        maxLength: 59,
        placeholder: this.$t('message.validator.input', { input: this.$t('message.user.merchantNameEn').toLowerCase() }),
        tipList: [{
          key: '',
          value: this.$t('message.user.merchantNameEnTips'),
        }],
        validator: this.validateMerchantNameEn,
      }, {
        key: 'registerDate',
        name: 'message.user.merchantRegisterDate',
        type: 'date_time',
        dateType: 'date',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        dateFormat: 'yyyy-MM-dd',
        dateValueFormat: 'yyyy-MM-dd',
        validator: this.validateRegisterDate,
      });
    }
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    initMethod() {
      if (this.info.registration) {
        this.$refs.businessFormRef.setItemValue('registration', this.info.registration);
      }
      if (this.info.merchantName) {
        this.$refs.businessFormRef.setItemValue('merchantName', this.info.merchantName);
      }
      if (`${this.info.businessType}` === '0') { // 付款商户时
        if (this.info.merchantNameEn) {
          this.$refs.businessFormRef.setItemValue('merchantNameEn', this.info.merchantNameEn);
        }
        if (this.info.registerDate) {
          this.$refs.businessFormRef.setItemValue('registerDate', this.info.registerDate);
        }
      }
    },
    validateMerchantNameEn(rule, value, callback) {
      // 必填验证
      if (REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.input', { input: this.$t('message.user.merchantNameEn').toLowerCase() })));
        return;
      }
      if (!ENGLISH_NAME.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.inputEnglish')));
        return;
      }
      if (value.length < 10 || value.length >= 60) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[10, 60)' })));
        return;
      }
      callback();
    },
    validateRegisterDate(rule, value, callback) {
      // 必填验证
      if (!value || REQUIRED.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.select', { input: this.$t('message.user.merchantRegisterDate').toLowerCase() })));
        return;
      }
      callback();
    },
    async submit() {
      return new Promise((resolve, reject) => {
        this.$refs.businessFormRef.toFormValid((params) => {
          resolve(params);
        }, () => {
          reject(new Error('toFormValid error'));
        });
      });
    },
    async onSubmit() {
      try {
        const res = await this.submit();
        this.$emit('finish', res);
      } catch (err) {
      }
    },
  },
};
</script>

<style>

</style>
